import React, { Component, PropTypes } from 'react'

import SingleDatePicker from './single-date-picker'

class SingleDatePickerContainer extends Component {

  constructor(props) {
    super(props)

    this.handleDayClick = this.handleDayClick.bind(this)
  }

  handleDayClick(date, modifiers) {
    const dateString = this.props.format(date)

    if (modifiers.includes('selected')) {
      this.props.onChange(this.props.dates.filter(d => d !== dateString))
    } else {
      this.props.onChange(this.props.dates.concat(dateString))
    }
  }

  render() {
    return (
      <SingleDatePicker
        {...this.props}
        format={this.props.format}
        onDayClick={this.handleDayClick}
      />
    )
  }

}

SingleDatePickerContainer.propTypes = {
  dates: PropTypes.array.isRequired,
  format: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onContinue: PropTypes.func.isRequired,
}

export default SingleDatePickerContainer



/** WEBPACK FOOTER **
 ** ./src/components/single-date-picker/single-date-picker-container.js
 **/